import { render, staticRenderFns } from "./createBatch.vue?vue&type=template&id=3a897ad1&"
import script from "./createBatch.vue?vue&type=script&lang=js&"
export * from "./createBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports